import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[inputrestriction]'
})
export class InputrestrictionDirective {

  @Input('inputrestriction') InputRestriction!: string;

  private element : ElementRef;
  returnValue!: string;

  constructor(element : ElementRef) {
    this.element = element;
  }

  @HostListener('keypress', ['$event'])
  handleKeyPress(event : KeyboardEvent)
  {
    if (this.InputRestriction.toUpperCase() == 'SOMENTELETRAS') {
      this.returnValue = '[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕc \b]';
    } else if (this.InputRestriction.toUpperCase() == 'SOMENTENUMEROS') {
      this.returnValue = '[0-9]';
    }

    var regex = new RegExp(this.returnValue);
    var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (regex.test(str)) {
        return true;
    }

    event.preventDefault();
    return false;
  }

}
